import { Button, Form, Spinner } from 'react-bootstrap'
import { Modal, Placeholder, Input } from 'rsuite';

import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import "./MainEditPage.css"
import ChartCheckbox from '../../../Dashboard/Tools/ChartCheckbox';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select'
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

export default function MainEditPage() {
    const nav = useNavigate();

    const userx = useSelector(state => state.user);

    const [searchParams] = useSearchParams();
    const AffiliateID = searchParams.get('id');
    const StoreUser = useSelector((state) => state.user);
    const [affiliate, setAffiliate] = useState({})
    const [ltLang, setLtLang] = useState([])
    const [ltCount, setLtCount] = useState([])
    const [selectedOption, setSelectedOption] = useState(null);
    const [editForm, setEditForm] = useState(false);
    const [ltMesg, setLtMesg] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [note, setNote] = useState("");
    const [noteLoading, setNoteLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [emailVerified, setEmailVerified] = useState(true);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const handleOpen = () => {
        if (checkPermission(affliate, "aff_edit_affiliates"))
            setOpen(true)
    };
    const handleClose = () => setOpen(false);
    const [rtfaloading, setRtfaloading] = useState(false);
    const [editloading, setEditloading] = useState(false);
    const [editPassLoading, setEditPassLoading] = useState(false);
    const [affliate, setAffliate] = useState({});
    const [ChangePassword, SetChangePassword] = useState({
        newpassword: "",
        repassword: ""
    })
    const [affvariables, setAffVariables] = useState({
        players : "",
        amount : ""
    })
    const [vloading, setVloading] = useState(false);

    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getAffiliateById = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetAffiliate/" + AffiliateID, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setAffiliate(response.data.Result);
            setAffVariables(response.data.Variables);
        }
    }
    const getListLanguages = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtLang(response.data.Result)
        }
    }
    
    const getListCountries = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCountries", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtCount(response.data.Result)
        }
    }
    const handleChange = (selected) => {
        setSelectedOption(selected);
    };
    useEffect(() => {
        getAffiliateById();
        getListLanguages();
        getListCountries();
        getListMessenger();
        getPaymentMethods();
    }, [])
    const getListMessenger = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllMessengers", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtMesg(response.data.Result)
        }
    }
    const partnerOptions = [{ label: "partner", value: 0 }]
    const statusOptions = [{ label: "Active", value: 0 }, { label: "On Review", value: 1 }, { label: "Declined", value: 3 }, { label: "Inactive", value: 4 }]
    const selectedCoutnryOption = ltCount.find(option => option.value === affiliate.Country);
    const selectedLanguageOption = ltLang.find(option => option.value === affiliate.Language);
    const selectedStatusOptions = statusOptions.find(option => option.value === affiliate.Status);
    const selectedMessenger = ltMesg.find(option => option.value === affiliate.Messenger);
    const labelselectedMessenger = selectedMessenger?.label;
    const editAffiliate = async () => {
        setEditloading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/EditAffiliate/" + AffiliateID, {
            site: affiliate.Site,
            email: affiliate.Email,
            messenger: affiliate.Messenger,
            messengerusername: affiliate.MessengerUsername,
            phone: affiliate.Phone,
            country: affiliate.Country,
            language: affiliate.Language,
            paymentmethod: affiliate.PaymentMethod,
            paymentdetails: affiliate.PaymentDetails,
            status: affiliate.Status
        },
            {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("raff-token")
                }
            })

        setEditloading(false);

        if (response.data.Error === null) {
            toast.success("Updated Sucessufully", {
                duration: 4000
            });
            getAffiliateById()
            setEditForm(false)
        }
        else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }
    const getPaymentMethods = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllPayments", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setPaymentMethods([
                {
                    value : null,
                    label : "No Method"
                },
                ...response.data.Result.filter(d => {
                    return d.value !== ""
                })
            ])
        }
    }
    const selectedMethodOptions = paymentMethods.find(option => option.value === affiliate.PaymentMethod)
    const reset2FA = async () => {
        setRtfaloading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/ResetAfiliate2FA/" + AffiliateID, {}, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setRtfaloading(false);

        if (response.data.Error === null) {
            toast.success("Updated Sucessufully", {
                duration: 4000
            });
            getAffiliateById()
        }
        else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }
    const ChangePasswords = async () => {
        setEditPassLoading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/ResetAffiliatePassword/" + AffiliateID, ChangePassword, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setEditPassLoading(false);

        if (response.data.Error === null) {
            toast.success("Updated Sucessufully", {
                duration: 4000
            });
            SetChangePassword({
                newpassword: "",
                repassword: ""
            })
            handleClose()
        }
        else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    const LoginAffiliate = async () => {
        const response = await axios.post(window.__CFG.API + "affiliates/LoginAffiliateAccount/" + AffiliateID, {}, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            toast.success("Logging in", {
                duration: 4000
            });
            window.open(window.__CFG.AffiliateURI + "signin/token/"+response.data.Result, "target=_blank")
        } else {
            toast.error("Failed to login", {
                duration : 4000
            })
        }
    }

    const EditNote = async () => {
        setNoteLoading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/SaveAffiliateNote/" + AffiliateID, {
            note : note
        }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setNoteLoading(false);

        if (response.data.Error === null) {
            toast.success("Note saved", {
                duration: 4000
            });
        }
        else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    useEffect(() => {
        if(affiliate.Note != undefined) {
            setNote(affiliate.Note)
        }
    }, [affiliate]);

    const SaveVariables = async () => {
        setVloading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/SaveVariables/" + AffiliateID, affvariables, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        });
        setVloading(false);

        if(response.data.Error == null) {
            getAffiliateById();
            toast.success("Variables Updated Sucessufully", {
                duration: 4000
            });
        } else {
            toast.success(response.data.Error, {
                duration: 4000
            });
        }
    }

    const GetEmailStatus = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetEmailStatus/" + AffiliateID, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        if(response.data.Error == null) {
            setEmailVerified(response.data.Status);
        }
    }

    useEffect(() => {
        GetEmailStatus();
    }, [])

    const ResendVerificationEmail = async () => {
        if(resendLoading) {
            return false;
        }
        setResendLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/ResendVerificationEmail/" + AffiliateID, {}, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setResendLoading(false);
        if(response.data.Error == null) {
            toast.success("Verification email resent successfully.", {
                duration: 4000
            });
        } else {
            toast.error("There was an error while sending verification email.", {
                duration: 4000
            });
        }
    }

    const VerifyEmail = async () => {
        if(verifyLoading) {
            return false;
        }
        setVerifyLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/VerifyEmail/" + AffiliateID, {}, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        if(response.data.Error == null) {
            setVerifyLoading(false);
            GetEmailStatus()
        } else {
            setVerifyLoading(false);
            GetEmailStatus();
        }
    }

    const GenerateInvoice = async (id) => {
        setInvoiceLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/GenerateManualInvoice/" + id, {}, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setInvoiceLoading(false);
        if(response.data.Error == null) {
            toast.success("Invoice Generate Successfully.", {
                duration: 4000
            });
        }
    }

    return (
        <>
            <div className="Main-Edit-wp" style={{ marginTop: 20 }}>
                <div>
                    ID {AffiliateID}; {selectedCoutnryOption?.label} {statusOptions?.label}
                </div>
                <div className='aff-menu'>
                    <div className="aff-row-menu">
                        <div className='aff-row'>
                        {checkPermission(affliate, "aff_login_affiliate") ? (
                            <div className="aff-col">
                                <Button onClick={LoginAffiliate} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                >
                                    Login affiliate account
                                </Button>
                            </div>
                            ) : (<></>)}
                            {checkPermission(affliate, "aff_edit_affiliates") ? (

                                <div className="aff-col">
                                    <Button onClick={handleOpen} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                    >
                                        Reset password
                                    </Button>
                                </div>
                            ) : (<></>)}
                            {
                                !emailVerified ? (
                                    <>
                                        {checkPermission(affliate, "aff_edit_affiliates") ? (
                                        <div className="aff-col">
                                            <Button onClick={ResendVerificationEmail} disabled={resendLoading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                            >
                                                Resend Verification Email
                                            </Button>
                                        </div>
                                        ) : (<></>)}
                                        {checkPermission(affliate, "aff_edit_affiliates") ? (
                                        <div className="aff-col">
                                            <Button onClick={VerifyEmail} disabled={verifyLoading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                            >
                                                Verify Email
                                            </Button>
                                        </div>
                                        ) : (<></>)}
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {checkPermission(affliate, "aff_pay_bonus") ? (
                                <div className="aff-col">
                                    <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                        onClick={() => nav('/affiliate/details/bonus?id=' + AffiliateID)}
                                    >
                                        pay bonus
                                    </Button>
                                </div>
                            ) : (<></>)}
                            {checkPermission(affliate, "aff_edit_groups") ? (
                                <div className="aff-col">
                                    <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                        onClick={() => nav('/affiliate/details/group?id=' + AffiliateID)}
                                    >
                                        Groups
                                    </Button>
                                </div>
                            ) : (<></>)}
                            {checkPermission(affliate, "aff_domain_api") ? (

                                <div className="aff-col">
                                    <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                        onClick={() => nav('/affiliate/details/afflinkdomain?id=' + AffiliateID)}
                                    >
                                        Domain settings
                                    </Button>
                                </div>) : (<></>)}
                            <div className="aff-col">
                                <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                    onClick={() => nav('/affiliate/details/affsites?id=' + AffiliateID)}
                                >
                                    Affiliate sites
                                </Button>
                            </div>
                            <div className="aff-col">
                                <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                    onClick={() => nav('/affiliate/details/promo?id=' + AffiliateID)}
                                >
                                    Promo codes
                                </Button>
                            </div>
                            {
                                userx.User != null && userx.User.Permissions == null ? (
                                    <div className="aff-col">
                                        <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                            onClick={() => nav('/affiliate/affiliate-players?id=' + AffiliateID)}
                                        >
                                            Players
                                        </Button>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                userx.User != null && userx.User.Permissions == null ? (
                                    <div className="aff-col">
                                        <Button disabled={invoiceLoading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                            onClick={() => GenerateInvoice(AffiliateID)}
                                        >
                                            Generate Invoice
                                        </Button>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {/* <div className="aff-col">
                                <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                    onClick={() => nav('/affiliate/details/affApk')}
                                >
                                    APK
                                </Button>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className='aff-main-data-section'>
                    <div className='aff-main-data-section-usr'>
                        <div className='aff-user-lbl'>
                            {affiliate.Username}
                        </div>
                        <div className='aff-user-ggl'>
                            <div className='aff-user-ggl-lbl'>
                                Google Authenticator enabled: {affiliate.TFAEnabled ? <b>Yes</b> : "No"}
                            </div>
                            {
                                affiliate.TFAEnabled ? (
                                    <div className='aff-user-ggl-btn'>
                                        <Button disabled={rtfaloading} onClick={reset2FA} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                        >
                                            {
                                                rtfaloading ? (
                                                    <Spinner size="sm"></Spinner>
                                                ) : (
                                                    <>Reset 2FA</>
                                                )
                                            }
                                        </Button>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {!editForm && checkPermission(affliate, "aff_edit_affiliates") ? (
                                <div className='aff-user-edit-btn'>
                                    <span onClick={() => setEditForm(!editForm)} style={{ cursor: "pointer" }}>   Edit information</span>
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className='aff-main-data-wp'>
                        <div className='aff-main-data'>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Site:
                                    </div>
                                    {!editForm ? (
                                        <div className='aff-col-data-cnt'>
                                            {affiliate.Site}
                                        </div>
                                    ) : (
                                        <>
                                            <div className='aff-col-data-cnt'>
                                                <Form.Control type='text' value={affiliate.Site} onChange={e => { setAffiliate({ ...affiliate, Site: e.target.value }) }} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Email:
                                    </div>
                                    {!editForm ? (

                                        <div className='aff-col-data-cnt'>
                                            {affiliate.Email}
                                        </div>
                                    ) : (
                                        <>
                                            <div className='aff-col-data-cnt'>
                                                <Form.Control type='text' value={affiliate.Email} onChange={e => { setAffiliate({ ...affiliate, Email: e.target.value }) }} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Messenger:
                                    </div>
                                    {!editForm ? (

                                        <div className='aff-col-data-cnt'>
                                            {labelselectedMessenger}
                                        </div>
                                    ) : (
                                        <>
                                            <div className='aff-col-data-cnt'>
                                                <Select options={ltMesg} value={selectedMessenger} onChange={e => { setAffiliate({ ...affiliate, Messenger: e.value }) }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Messenger username:
                                    </div>
                                    {!editForm ? (

                                        <div className='aff-col-data-cnt'>
                                            {affiliate.MessengerUsername}
                                        </div>
                                    ) : (
                                        <>
                                            <div className='aff-col-data-cnt'>
                                                <Form.Control type='text' value={affiliate.MessengerUsername} onChange={e => { setAffiliate({ ...affiliate, MessengerUsername: e.target.value }) }} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Phone number:
                                    </div>
                                    {!editForm ? (

                                        <div className='aff-col-data-cnt'>
                                            {affiliate.Phone}
                                        </div>
                                    ) : (
                                        <>
                                            <div className='aff-col-data-cnt'>
                                                <Form.Control type='text' value={affiliate.Phone} onChange={e => { setAffiliate({ ...affiliate, Phone: e.target.value }) }} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Registration date:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        {affiliate.RegistrationDate}
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Registration Source:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        {affiliate.RegistrationSource}
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Date of the last payment:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        {affiliate.LastPaymentDate}
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Players:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        {affiliate.Players}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='aff-main-data'>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Partner type
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Select isDisabled={!editForm} options={partnerOptions} />

                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Introduced by
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Form.Control disabled={!editForm} type='text' style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Introduced by (Site ID):
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Form.Control disabled={!editForm} type='text' style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Status:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Select isDisabled={!editForm} options={statusOptions} value={selectedStatusOptions} onChange={e => { setAffiliate({ ...affiliate, Status: e.value }) }} />
                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Country:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Select isDisabled={!editForm} options={ltCount} value={selectedCoutnryOption} onChange={e => { setAffiliate({ ...affiliate, Country: e.value }) }} />

                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Language:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Select isDisabled={!editForm} options={ltLang} value={selectedLanguageOption} onChange={e => { setAffiliate({ ...affiliate, Language: e.value }) }} />

                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Preferred payment method:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Select isDisabled={!editForm} options={paymentMethods} value={selectedMethodOptions} onChange={e => { setAffiliate({ ...affiliate, PaymentMethod: e.value }) }} />

                                    </div>
                                </div>
                            </div>
                            <div className='aff-main-data-col'>
                                <div className='aff-col-data'>
                                    <div className='aff-col-data-lbl'>
                                        Wallet number:
                                    </div>
                                    <div className='aff-col-data-cnt'>
                                        <Form.Control disabled={!editForm} type='text' value={affiliate.PaymentDetails} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} onChange={e => { setAffiliate({ ...affiliate, PaymentDetails: e.target.value }) }} />
                                    </div>
                                </div>
                            </div>

                            <div className='aff-main-data-col'>
                                <div className='aff-col-data-lbl'>
                                </div>
                                {editForm ? (
                                    <div className='aff-col-data-cnt'>
                                        <Button disabled={!checkPermission(affliate, "aff_edit_affiliates") || editloading} onClick={editAffiliate} style={{ float: "right" }} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp " >{editloading ? <Spinner size="sm" /> : <>Edit</>}</Button>
                                    </div>) : (<></>)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='aff-payment-check'>
                    <div className='aff-checkbox'>
                        <ChartCheckbox label='' size='14px' />
                    </div>
                    <div className='aff-checkbox-lbl'>
                        Receive payments automatically
                    </div>
                </div>
                <div className='aff-payment-check'>
                    <div className='aff-checkbox'>
                        <ChartCheckbox label='' size='14px' />
                    </div>
                    <div className='aff-checkbox-lbl'>
                        Receive payments once a month
                    </div>
                </div>

                <div style={{ marginBottom : "25px", marginTop : "30px" }}> 
                    <h6>Affiliate Variables</h6>
                    <div className='aff-col-data-lbl' style={{ minWidth : "100%", width : "100%" }}>
                        Minimum players for invoice generation
                        <Input value={affvariables.players} onChange={value => setAffVariables({...affvariables, players : value})} placeholder="Minimum players" style={{ fontSize : "12px" }}></Input>
                    </div>
                    <div className='aff-col-data-lbl' style={{ minWidth : "100%", width : "100%" }}>
                        Minimum amount for invoice generation
                        <Input value={affvariables.amount} onChange={value => setAffVariables({...affvariables, amount : value})} placeholder="Minimum amount" style={{ fontSize : "12px" }}></Input>
                    </div>
                    <div className='aff-col-data-cnt'> 
                        <Button disabled={vloading} onClick={SaveVariables} style={{ float: "right" }} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp " >{noteLoading ? <Spinner size="sm" /> : <>Save Variables</>}</Button>
                    </div>
                </div>

                <div style={{ marginBottom : "25px" }}> 
                    <div className='aff-col-data-lbl'>
                        Note:
                    </div>
                    <div className='aff-col-data-cnt'> 
                        <textarea onChange={e => setNote(e.target.value)} className='aff-col-note' value={note}></textarea>
                        <Button disabled={noteLoading} onClick={EditNote} style={{ float: "right" }} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp " >{noteLoading ? <Spinner size="sm" /> : <>Save Note</>}</Button>
                    </div>
                </div>
            </div>

            <Modal open={open} onClose={handleClose}>
                <Modal.Header>
                    <Modal.Title>Reset affiliate password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ paddingBottom: 10 }}>
                        <div style={{ paddingBottom: 10 }}>
                            <label>New Password</label>
                        </div>
                        <Form.Control type='password' onChange={e => SetChangePassword({ ...ChangePassword, newpassword: e.target.value })} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                    </div>
                    <div>
                        <div style={{ paddingBottom: 10 }}>
                            <label> retype New Password</label>
                        </div>
                        <Form.Control type='password' onChange={e => SetChangePassword({ ...ChangePassword, repassword: e.target.value })} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={editPassLoading} onClick={ChangePasswords} className='btn-com-grp' style={{ borderRadius: 0 }} >
                        {
                            editPassLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <>Reset Password</>
                            )
                        }
                    </Button>
                    <Button style={{ marginLeft: 10, backgroundColor: "#fff", color: "#000", borderColor: "#fff" }} onClick={handleClose} appearance="subtle">
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}